export const createArrayOfObjects = (
    length: number,
    template: object
): object[] => {
    return Array.from({ length }, () => ({ ...template }));
};

export const disableBodyScroll = () => {
    const body = document.querySelector('body');

    body.style.overflowY = 'hidden';
};

export const enableBodyScroll = () => {
    const body = document.querySelector('body');

    body.style.overflowY = 'auto';
};

export const getBaseUrl = () => {
    return window.location.href.split('?')[0];
};

const getMarketName = (marketName) => {
    let market1, market2;

    if (!marketName) return;

    const lastSpaceIndex = marketName.lastIndexOf(' ');

    if (lastSpaceIndex !== -1) {
        market1 = marketName.substring(0, lastSpaceIndex);
        market2 = marketName.substring(lastSpaceIndex + 1);
    } else {
        market1 = marketName;
        market2 = undefined;
    }

    return {
        market1,
        market2
    };
};

export const getOriginalPrice = (data, marketName) => {
    if (!marketName || !data) return;
    const { market1, market2 } = getMarketName(marketName);

    for (const key of Object.keys(data)) {
        if (key.includes(`${market1} ${market2}_Original`)) {
            return data[key];
        }
    }

    return null;
};

export const getPriceForMarket = (data, marketName) => {
    if (!marketName || !data) return;
    const { market1, market2 } = getMarketName(marketName);

    for (const key of Object.keys(data)) {
        if (key.includes(`${market1} ${market2}_All Customers`)) {
            return data[key];
        }
    }

    return null;
};

const extractNumber = (str: string) => {
    let string = str;

    if (typeof string !== 'string') {
        string = str.toString();
    }

    const matched = string.match(/(\d+(\.\d+)?)/);
    return matched ? parseFloat(matched[0]) : null;
};

export const getGa4Data = (
    index,
    productData,
    value,
    price: string,
    qty,
    categoryData
) => {
    return (
        price && {
            affiliation: 'Evergreen',
            index: index,
            item_id: productData.SKU,
            item_name: value,
            item_brand: productData.Brand,
            item_list_id: categoryData.display_name,
            item_list_name: categoryData.group_id,
            price: extractNumber(price),
            quantity: qty
        }
    );
};

export const getDiscountPercent = (price, discount) => {
    const discountAmount = (price * discount) / 100;
    const finalPrice = price - discountAmount;

    return priceRound(finalPrice);
};

export const priceRound = (price) => {
    const factor = Math.pow(10, 2);
    return (Math.ceil(price * factor) / factor).toFixed(2);
};

export const formatNumber = (num: number) => {
    if (typeof num !== 'number' || isNaN(num)) return null;

    const str = num.toString();
    const decimalPart = str.split('.')[1];

    if (decimalPart && decimalPart.length >= 2) {
        return str;
    } else {
        return num.toFixed(2);
    }
};

export const getObjectByDefaultVariant = (item) => {
    if (item.variations?.length === 1) {
        return item.data;
    }

    if (!item?.variations) return;
    const defaultVariant = item.data['default_variant '].toString();

    const defaultObject = item.variations?.find(
        (variation) => variation.data.SKU === defaultVariant
    );

    return defaultObject?.data?.IsCustomized
        ? defaultObject.data
        : item.variations[0]?.data;
};

export const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
};

export const getLicensedCollectionsFilterValue = (facets: []) => {
    if (!facets.length) return;

    const licensedCollectionsFilter = facets.find(
        (facet) => facet.name === 'LicensedCollections_Filter'
    );

    const firstValue = licensedCollectionsFilter
        ? licensedCollectionsFilter.values[0]
        : null;

    return firstValue;
};

export const getApiKey = () => {
    const stagingKey = 'key_0noanbI2Z65zxHZo';
    const productionKey = 'key_cqnWKsLdLroVSpbs';

    if (window.location.href.includes('inte.myevergreenonline.com')
        || window.location.href.includes('prep.myevergreenonline.com')) {
        return stagingKey;
    }

    return productionKey;
};

export const filterSortingOptions = (data, market) => {
    let { MarketName } = market;

    const filteredSortOpts = data.filter(({ sort_by }) =>
        sort_by.startsWith('Price_')
            ? sort_by.includes(`${MarketName}_All Customers`)
            : true
    );

    if (!filteredSortOpts.some(({ sort_by }) => sort_by.includes(MarketName))) {
        filteredSortOpts.push(
            ...data.filter(
                ({ sort_by }) => sort_by === 'Price_Retailer US_All Customers'
            )
        );
    }

    return filteredSortOpts;
};

export const transformSortData = (data, market) => {
    if (!data) return;
    const filteredSortingOptions = market ? filterSortingOptions(data, market) : data;

    return filteredSortingOptions?.map((item) => ({
        data: item.sort_by,
        display_name: item.display_name,
        sort_order: item.sort_order
    }));
};

export const getSortByValue = (marketName, displayName) => {
    const filteredData = filterSortingOptions(sortOpts, marketName);
    const item = filteredData.find(
        ({ display_name }) => display_name === displayName
    );

    return item ? item.sort_by : null;
};

const sortOpts = [
    {
        sort_order: 'descending',
        sort_by: 'relevance',
        display_name: 'Relevance'
    },
    {
        sort_order: 'descending',
        sort_by: 'Flag_2_BestSeller',
        display_name: 'Best Sellers'
    },
    {
        sort_order: 'descending',
        sort_by: 'Flag_1_New',
        display_name: 'New'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Harley Davidson US_Case pack price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Harley Davidson US_Case pack price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Harley Davidson US_Discounted price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Harley Davidson US_Discounted price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Hearth CAN_All Customers',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Hearth CAN_All Customers',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Hearth CAN_Discounted price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Hearth CAN_Discounted price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Hearth US_All Customers',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Hearth US_All Customers',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Hearth US_Discounted price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Hearth US_Discounted price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Retailer CAN_All Customers',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Retailer CAN_All Customers',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Retailer CAN_Case pack price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Retailer CAN_Case pack price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Retailer CAN_Discounted price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Retailer CAN_Discounted price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Retailer US_All Customers',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Retailer US_All Customers',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Retailer US_Case pack price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Retailer US_Case pack price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Retailer US_Discounted price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Retailer US_Discounted price',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Admin US_All Customers',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Admin US_All Customers',
        display_name: 'Price (High to Low)'
    },
    {
        sort_order: 'ascending',
        sort_by: 'Price_Admin US_Discounted price',
        display_name: 'Price (Low to High)'
    },
    {
        sort_order: 'descending',
        sort_by: 'Price_Admin US_Discounted price',
        display_name: 'Price (High to Low)'
    }
];
